import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import DeleteModal from "./modals/DeleteModal";
import Home from "./pages/Home";
import Transactions from "./pages/Transactions";

function App() {
	const [deleteMode, setDeleteMode] = useState(false);
	const { deleting } = useSelector(state => state.transaction)

	useEffect(() => {
		const {id} = deleting || {};
		if(id) {
			setDeleteMode(true);
		} else {
			setDeleteMode(false);
		}
	}, [deleting])

	return (
		<Router>
			{deleteMode && <DeleteModal />}
			<Layout>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/transactions" element={<Transactions />} />
				</Routes>
			</Layout>
		</Router>
	);
}

export default App;
